import get from 'lodash/get';

import {
  ADMIN_LIST_REQUESTED,
  GET_PERSON_LIST_SUCCESS,
} from '../actionConstants';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADMIN_LIST_REQUESTED:
      return get(action, 'payload.data', {});
    case GET_PERSON_LIST_SUCCESS:
      return get(action, 'res.data');
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
